
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1.234","y":".5","width":"19","height":"19","rx":"9.5","fill":"#46D064"}}),_c('path',{attrs:{"d":"M8.976 13.906L5.55 10.454a.38.38 0 010-.536l-.354-.352.354.352a.38.38 0 01.54 0l2.531 2.543.355.357.355-.357 6.043-6.09a.383.383 0 11.544.54l-6.942 6.995z","fill":"#fff","stroke":"#fff"}}),_c('rect',{attrs:{"x":"1.234","y":".5","width":"19","height":"19","rx":"9.5","stroke":"#46D064"}})])
          )
        }
      }
    